<template>
  <card>
    <el-tabs :value="activeName" @input="$emit('update:activeName', $event)">
      <el-tab-pane
        v-for="domain in domains"
        :key="domain.language"
        :label="domain.language.toUpperCase()"
        :name="tabLabel(domain.language)"
      >
        <div
          v-for="field in fields"
          :key="`${domain.language}-${field.key}`"
          class="mb-3"
        >
          <base-input
            v-if="field.input === 'base'"
            :label="fieldLabel(field, domain.language)"
            :placeholder="field.placeholder(domain.language)"
            v-model="form[field.key][domain.language]"
          />
          <template v-else-if="field.input === 'textarea'">
            <label>{{ field.label }} {{ domain.language.toUpperCase() }}</label>
            <el-input
              type="textarea"
              :rows="field.rows"
              v-model="form[field.key][domain.language]"
              :placeholder="field.placeholder(domain.language)"
            />
          </template>
        </div>
      </el-tab-pane>
    </el-tabs>
  </card>
</template>

<script>
export default {
  name: "OfferFormTextTabs",
  props: {
    domains: { type: Array, required: true },
    fields: { type: Array, required: true },
    form: { type: Object, required: true },
    activeName: { type: String, default: null },
    tabLabel: { type: Function, required: true },
    fieldLabel: { type: Function, required: true }
  }
};
</script>
